
<template>
	<div class="box">
	  <div class="boxTitle">进出口贸易额对比</div>
	  <div class="echart">
	    <!-- <div id="echarts" style="height:400px;width: 100%;"></div> -->

      <div>
        <dv-active-ring-chart :config="config" style="width:150px;height:150px" />
        <div class="year">2021年</div>
      </div>
      <div>
        <dv-active-ring-chart :config="config1" style="width:150px;height:150px" />
        <div class="year">2022年</div>
      </div>
      <div>
        <dv-active-ring-chart :config="config2" style="width:150px;height:150px" />
        <div class="year">2023年</div>
      </div>

	  </div>
	</div>
</template>

<script>
  import * as echarts from 'echarts';
	export default {
		name: "Three",
		data() {
      return {
        Chart:null,
        option:null,
        config:{
          radius: '50%',
          activeRadius: '55%',
          color:['#65B8F8','#87F7C7'],
          data: [
            {
              name: '进口',
              value: 80
            },
            {
              name: '出口',
              value: 20
            },
          ],
          digitalFlopStyle: {
            fontSize: 16,
            fill: '#fff'
          },
        },
        config1:{
          radius: '50%',
          activeRadius: '55%',
          color:['#65B8F8','#87F7C7'],
          data: [
            {
              name: '进口',
              value: 35
            },
            {
              name: '出口',
              value: 65
            },
          ],
          digitalFlopStyle: {
            fontSize: 16,
            fill: '#fff'
          },
        },
        config2:{
          radius: '50%',
          activeRadius: '55%',
          color:['#65B8F8','#87F7C7'],
          data: [
            {
              name: '进口',
              value: 15
            },
            {
              name: '出口',
              value: 85
            },
          ],
          digitalFlopStyle: {
            fontSize: 16,
            fill: '#fff'
          },
        }
      }
		},
    mounted() {
      //this.datainfo();
    },
    methods:{
      datainfo() {
        this.Chart = this.$echarts.init(document.getElementById('echarts'));
        this.option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
               axisLine: {
                    lineStyle: {
                        color: '#fff'
                    }
                },
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              splitLine:{
                show:false//取消x轴 金额刻度
              },
              type: 'value',
              axisLine: {
                  lineStyle: {
                      color: '#fff' // 设置 y 轴颜色为蓝色
                  }
              },
            }
          ],
          series: [
             {
              name: 'Direct',
              type: 'bar',
              emphasis: {
                focus: 'series'
              },
              data: [320, 332, 301, 334, 390, 330, 320],
              itemStyle: {  // 使用方法二的写法
                emphasis:{
                  barBorderRadius:80
                },
                normal:{
                   barBorderRadius:80,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#0076F5'},
                      {offset:0.5, color:'#00A1C2'},
                      {offset:1,color:'#00CF88'},
                    ]
                   )
                },
              },
            },
            {
              name: 'Email',
              type: 'bar',
              stack: 'Ad',
              emphasis: {
                focus: 'series'
              },
              itemStyle: {  // 使用方法二的写法
                emphasis:{
                  barBorderRadius:80
                },
                normal:{
                   barBorderRadius:80,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                      {offset:0, color:'#F6C40D'},
                      {offset:0.5, color:'#7B9D83'},
                      {offset:1,color:'#0376F6'},
                    ]
                   )
                }
              },
              data: [120, 132, 101, 134, 90, 230, 210]
            },
          ]
        };

        this.Chart.setOption(this.option);
      }
    }
	}

</script>

<style scoped>
  .echart{
    display:flex;
    justify-content:space-between;
    max-width: 1000px;
    margin: auto;
  }
  .year{
    text-align: center;
    font-size: 16px;
    color:rgba(255, 255, 255, 0.498039215686275);
    padding-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/left/three.vue